<template>
  <div>
    <h5>Подтверждение кода из смс {{ order.client.phone }}</h5>
    <fg-input :type="`number`" :label="`Введите код из смс, которое пришло клиенту`" v-model="code"></fg-input>
    <br />
    <br />
    <div class="install-control">
      <button @click="next" class="btn btn-success">{{ 'next_step' | setText('Далее') }}</button>
    </div>
  </div>
</template>
<script>
import { logger } from '../../../plugins/functions';

export default {
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0
    },
    hash: {
      default: null
    }
  },
  name: "filter",
  async created() {

  },
  methods: {

    next() {
      this.save();
    },
    prev() {
      this.$emit('next', this.index - 1);
    },
    save() {

      let dataSend = {
        phone: this.order.client.phone,
        hashCode: this.hash,
        code: this.code
      };

      logger(this.$http, {
        name: 'Подтврждение и добавление клиента в #PAYMART',
        description: 'Начало запроса',
        model_type: 'order',
        model_id: this.order.id
      });

      this.$loading(true);
      this.$http
        .post(`${this.partner['endpoint_url']}partner/buyers/check-sms-code`,
          dataSend,
          {
            headers: {
              'Authorization': `Bearer ${this.partner['api_secret_key']}`,
              'Content-Type': 'application/json'
            }
          })
        .then((response) => {
          if (response.data) {
            switch (response.data.status) {
              case 'success':
                this.message = 'Код подтвержден';
                // this.$emit('clientAccessToken', response.data.data.access_token);
                this.$emit('getBuyer', response.data.data.user_id);
                setTimeout(() => {
                  this.$emit('next', 3);
                }, 10);
                break;
              case 'error':
                this.message = 'Неверный код из смс';
                break;
              default:
                this.message = 'Неизвестная ошибка';
                break;
            }

            logger(this.$http, {
              name: 'Подтврждение и добавление клиента в #PAYMART',
              description: this.message,
              model_type: 'order',
              model_id: this.order.id
            });
            this.$notify({
              title: "PAYMART",
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          }

        })
        .catch((error) => {
          logger(this.$http, {
            name: 'Подтврждение и добавление клиента в #PAYMART',
            description: 'Ошибка партнера #PAYMART',
            model_type: 'order',
            model_id: this.order.id
          });
          alert('Ошибка партнера');
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      code: null,
      message: ''
    };
  },
};
</script>
<style lang="scss">

</style>
